exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms-and-conditions-form {\n  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.2);\n}\n.terms-and-conditions-body {\n  max-height: 500px;\n  overflow-y: auto;\n}\n.terms-and-conditions-input {\n  background-color: #f5f5f5;\n  margin: 10px;\n  padding: 15px 10px;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.terms-and-conditions-input label > span {\n  font-size: 22px;\n}\n.terms-and-conditions-input input {\n  margin-right: 10px;\n}\n.terms-and-conditions-input .checkbox {\n  margin-left: 20px;\n}\n.terms-and-conditions .ql-align-justify {\n  text-align: justify;\n}", ""]);

// exports
